import {
  EnumRichiestaDTOStatoPreventivi,
  RichiestaDTO,
} from '@framework/api-client';
import { useTranslation } from '@framework/i18n';

export function useQuoteActionRequiredMessages(
  submission: RichiestaDTO | null | undefined,
) {
  const { t } = useTranslation();

  return submission?.statoPreventivi ===
    EnumRichiestaDTOStatoPreventivi.DA_ACCETTARE
    ? t(
        'submission-state-tag.richiesta-accettazione-preventivo',
        "È richiesta l'accettazione del Preventivo",
      )
    : submission?.statoPreventivi === EnumRichiestaDTOStatoPreventivi.DA_PAGARE
    ? t(
        'submission-state-tag.richiesta-pagamento-preventivo',
        'È richiesto il pagamento del Preventivo',
      )
    : t(
        'submission-state-tag.sono-presenti-preventivi',
        'Sono presenti preventivi',
      );
}

interface IQuoteActionRequiredMessagesProps {
  submission: RichiestaDTO | null | undefined;
}

export function QuoteActionRequiredMessages(
  props: IQuoteActionRequiredMessagesProps,
) {
  const { submission } = props;
  const text = useQuoteActionRequiredMessages(submission);
  return text;
}
